// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-security-tab-content{width:100%}`, "",{"version":3,"sources":["webpack://./app/new-components/UserMenu/components/ProfileSecurityTabContent.scss"],"names":[],"mappings":"AAEA,8BACE,UAAA","sourcesContent":["@use 'assets/scss/common';\n\n.profile-security-tab-content {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
